import { render, staticRenderFns } from "./AsideReseller.vue?vue&type=template&id=5619b7e7&scoped=true"
import script from "./AsideReseller.vue?vue&type=script&lang=js"
export * from "./AsideReseller.vue?vue&type=script&lang=js"
import style0 from "./AsideReseller.vue?vue&type=style&index=0&id=5619b7e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619b7e7",
  null
  
)

export default component.exports